// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"225":"9536bdc7","230":"9536bdc7","237":"1445b90d","389":"9536bdc7","469":"f9d92da2"}[chunkId] + ".chunk.css";
};